import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetGroupsQuery } from './groupsApiSlice'
import { memo } from 'react'

const Group = ({ groupId }) => {
    const {type} = useParams()
    const { group } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            group: data?.entities[groupId]
        }),
    })

    const navigate = useNavigate()

    if (group) {     
        const handleEdit = () => navigate(`/${type}/0/groups/${groupId}`)
        const cellStatus = group.active ? '' : 'table__cell--inactive'
        return (
            <tr className="table__row">

                
                <td className={`table__cell group__name  ${cellStatus}`}>{group.name}</td>
                <td className={`table__cell group__company  ${cellStatus}`}>{group.companyname}</td>
                <td className={`table__cell group__year  ${cellStatus}`}>{group.year}</td>
                <td className={`table__cell group__year  ${cellStatus}`}>{group.archive?"V":"-"}</td>

                <td className={`table__cell  ${cellStatus}`}>
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                </td>
            </tr>
        )

    } else return null
}

const memoizedGroup = memo(Group)

export default memoizedGroup